module.exports = __webpack_public_path__ + "img/971ce9bc724c33b1871c63183a5af4ba.png";